import { render } from "./remisionGuideCRUD.vue?vue&type=template&id=72d91d24&scoped=true"
import script from "./remisionGuideCRUD.vue?vue&type=script&lang=js"
export * from "./remisionGuideCRUD.vue?vue&type=script&lang=js"

import "./remisionGuideCRUD.vue?vue&type=style&index=0&id=72d91d24&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d91d24"]])

export default __exports__